export const SERVER_URL = process.env.REACT_APP_SERVER_ADDRESS;
export const SERVER_COLLECTION = `${SERVER_URL}/collection`
export const SERVER_METADATA = `${SERVER_URL}/metadata`